<template>
  <div v-for="(project, index) in props.projects" class="project-row">
    <h3 class="project-name">{{ project }}</h3>
    <div class="color-boxes">
      <i class="fas fa-square" :style="`color: ${projectColorCoding[index][0]}`"></i>
      <i class="fas fa-square" :style="`color: ${projectColorCoding[index][1] || 'rgba(0,0,0,0)'}`"></i>
      <i class="fas fa-square" :style="`color: ${projectColorCoding[index][2] || 'rgba(0,0,0,0)'}`"></i>
      <i class="fas fa-square" :style="`color: ${projectColorCoding[index][3] || 'rgba(0,0,0,0)'}`"></i>
      <i class="fas fa-square" :style="`color: ${projectColorCoding[index][4] || 'rgba(0,0,0,0)'}`"></i>
    </div>
  </div>
</template>

<script setup>
 const props = defineProps({
   projects: {
     required: true,
     type: Object
   },

   projectColorCoding: {
     required: true,
     type: Object
   }
 });
</script>

<style scoped>
.project-row {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.project-name {
  display: inline-block;
  width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
}

.color-boxes {
  display: flex;
  gap: 5px;
}
</style>
